import React, { useEffect, useRef, useState } from "react";
import LoginImage from "../../../../../media/images/LoginImage.png";
import CustomButton from "../../../../components/CustomButton";
import LoginIcon from "../../../../../media/images/icons/login";
import ArrowLeft from "../../../../../media/images/icons/arrow-left";
import CustomTabBar from "../../../../components/CustomTabBar";
import CustomInput from "../../../../components/CustomInput";

import { Link, useNavigate } from "react-router-dom";
import {
  Grid,
  Box,
  Typography,
  TextField,
  InputLabel,
  useTheme,
} from "@mui/material";
import * as yup from "yup";
import LogoImage from "../../../../../media/images/icons/logo.svg";

import { useAppDispatch, useAppSelector } from "../../../../../hooks/useRedux";
import { changeLoginType } from "../../../../../redux/features/settingSlice";
import { useFormik } from "formik";
import MobileHeader from "../../../../layout/AuthLayout/MobileHeader";
import RegisterLink from "../RegisterLink";
import ArrowLeftSVG from "../../../../../media/images/icons/arrow-left";
import BigCarIcon from "../../../../../media/images/icons/bigCar";
import { loginSchema } from "../../../../../form/authValidations";

export default function UserGrids() {
  const theme = useTheme();
  const divRef = useRef<HTMLDivElement>(null);
  const [hasScroll, setHasScroll] = useState(false);

  const appDispatch = useAppDispatch();

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const userLoginTab = useAppSelector((state) => state.setting.userLoginTab);

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    // validationSchema: loginSchema,
    onSubmit: (value, errors) => {
      setLoading(true);

      setTimeout(() => {
        setLoading(false);
        navigate("/driver/dashboard");
      }, 3000);
    },
  });

  useEffect(() => {
    formik.resetForm();
  }, [userLoginTab]);

  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current && divRef.current.scrollTop > 5) {
        // Do something when scrolled more than 20 pixels
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
    };

    if (divRef.current) {
      divRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      // Cleanup: remove the event listener when the component unmounts
      if (divRef.current) {
        divRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <>
      <MobileHeader title="ورود صاحبین ‌بار و رانندگان" hasScroll={hasScroll} />
      <Box
        ref={divRef}
        sx={{
          flex: 1,
          // border: "4px solid green",
          overflowY: "auto",
        }}
      >
        <Grid
          container
          sx={{
            height: "100%",
          }}
        >
          <Grid
            sx={{
              // border: "1px solid gray",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              paddingTop: "12px",
              paddingX: {
                xs: "8px",
              },
            }}
            xs
            sm
            md={8}
            lg={8}
            item
          >
            <Box
              sx={{
                width: "100%",
                flex: 1,
                alignSelf: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  marginX: "auto",
                  width: {
                    xl: "40%",
                    lg: "60%",
                    md: "80%",
                    xs: "100%",
                  },
                }}
              >
                <Box
                  sx={{
                    mb: "16px",
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: {
                      xs: "flex",
                      md: "none",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "16px",
                    }}
                    color={"primary.main"}
                  >
                    ورود صاحبین بار و رانندگان
                  </Typography>

                  <Typography
                    onClick={() => appDispatch(changeLoginType())}
                    color={"secondary.main"}
                    sx={{
                      cursor: "pointer",
                    }}
                  >
                    شرکت حمل و نقل هستید؟{" "}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    backgroundColor: "background.default",

                    justifySelf: "center",
                    boxShadow: "0px 4px 15px 3px rgba(0,0,0,0.1)",
                    paddingX: "10px",
                    paddingY: "16px",
                    borderRadius: "16px",
                    marginX: "auto",
                  }}
                >
                  <CustomTabBar
                    color={{
                      main: theme.palette.primary.main,
                      light: theme.palette.primary.light,
                    }}
                    title={{
                      title1: "ورود صاحبان بار",
                      title2: "ورود رانندگان",
                    }}
                  />
                  <Box
                    sx={{
                      mt: "16px",
                      paddingX: "8px",
                    }}
                  >
                    <InputLabel
                      sx={{
                        color: "primary.main",
                        fontWeight: 600,
                        marginBottom: "8px",
                      }}
                      htmlFor="outlined-adornment-amount"
                    >
                      {userLoginTab === "burdenOwner"
                        ? "نام کاربری صاحب بار:"
                        : "نام کاربری راننده: "}
                    </InputLabel>

                    <CustomInput
                      errorMessage={
                        formik.touched.username && formik.errors.username
                      }
                      error={
                        formik.touched.username &&
                        Boolean(formik.errors.username)
                      }
                      name="username"
                      handelChange={formik.handleChange}
                    />
                  </Box>
                  <Box
                    sx={{
                      mt: "8px",
                      paddingX: "8px",
                    }}
                  >
                    <InputLabel
                      sx={{
                        color: "primary.main",
                        fontWeight: 600,
                        marginBottom: "8px",
                      }}
                      htmlFor="outlined-adornment-amount"
                    >
                      رمز عبور:
                    </InputLabel>
                    <CustomInput
                      errorMessage={
                        formik.touched.password && formik.errors.password
                      }
                      error={
                        formik.touched.password &&
                        Boolean(formik.errors.password)
                      }
                      name="password"
                      handelChange={formik.handleChange}
                    />
                    <Box
                      sx={{
                        marginTop: "8px",
                        paddingLeft: "8px",
                        border: "1px solid #D4D4D4",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        borderRadius: "12px",
                      }}
                    >
                      <TextField
                        multiline
                        size="small"
                        placeholder="پاسخ تصویر روبرو را وارد کنید..."
                        InputProps={{
                          style: {
                            fontSize: "14px",
                          },
                        }}
                        sx={{
                          whiteSpace: "wrap",
                          border: "none",
                          outline: "none",
                          "& fieldset": { border: "none" },
                          "& :placeholder": {
                            fontSize: "10px",
                          },
                        }}
                      />

                      <Box
                        sx={{
                          backgroundColor: "lightStatic.main",
                          padding: "4px",
                          paddingX: "16px",
                          borderRadius: "8px",
                        }}
                      >
                        <Typography color={"primary.main"}>
                          {"?=38+48"}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  <CustomButton
                    loading={loading}
                    onClick={formik.handleSubmit}
                    flexDirection="row"
                    title="ورود"
                    justifyContent="center"
                    bgColor="primary.main"
                    width="100%"
                    fSize="16px"
                    fontWeight={500}
                    px="10px"
                    py="10px"
                    borderRadius="10px"
                    color="lightStatic.main"
                    icon2={<LoginIcon size={32} />}
                    mt="16px"
                  />

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "16px",
                    }}
                  >
                    <Typography
                      sx={{
                        flex: "1",
                        fontSize: "14px",
                      }}
                    >
                      رمز عبور خود را فراموش کرده‌اید؟
                    </Typography>
                    <Link
                      to={"/"}
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          backgroundColor: "#FFD54F",
                          padding: "4px",
                          borderRadius: "8px",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "13px",
                            color: "textColor.main",
                            fontWeight: "600",
                          }}
                        >
                          فراموشی رمز عبور
                        </Typography>
                        <ArrowLeft color={theme.palette.textColor.main} />
                      </Box>
                    </Link>
                  </Box>
                </Box>

                <RegisterLink />
              </Box>

              {/*footer*/}
            </Box>
            <Box
              sx={{
                backgroundColor: {
                  md: "background.default",
                  width: "fit-content",
                  marginX: "auto",
                },
                padding: "4px",
                borderRadius: "4px",
              }}
            >
              <Typography variant="body2" color="textSecondary" align="center">
                © 2024 - تمام حقوق برای این نرم افزار محفوظ و متعلق به{" "}
                <Typography
                  component="span"
                  variant="body2"
                  color="secondary.main"
                >
                  شرکت کارن ترابر خلیج فارس
                </Typography>{" "}
                می‌باشد.
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={4}
            sx={{
              backgroundImage: `url(${LoginImage})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              display: {
                xs: "none",
                md: "flex",
              },
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                width: "100%",
                textAlign: "center",
                paddingY: "16px",
                paddingX: "10px",
                position: "relative",
                maxWidth: {
                  xl: "45%",
                  lg: "65%",
                  md: "80%",
                },
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  backgroundColor: "background.default",
                  opacity: "0.9",
                  borderRadius: "16px",
                }}
              ></Box>
              <Box
                sx={{
                  position: "relative",
                }}
              >
                <img width={70} src={LogoImage} alt="" />
                <Typography
                  sx={{
                    fontWeight: "900",
                    zIndex: 5,
                  }}
                  variant="h2"
                  color="secondary.main"
                >
                  {"ورود شرکت حمل و نقل"}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "800",
                    color: "textColor.dark",
                    marginTop: "14px",
                  }}
                >
                  {"شرکت‌های حمل و نقل از این قسمت وارد داشبورد   خود شوند."}
                </Typography>
                <CustomButton
                  justifyContent="space-between"
                  onClick={() => appDispatch(changeLoginType())}
                  title="ورود شرکت حمل و نقل"
                  bgColor="secondary.main"
                  width="100%"
                  fSize="16px"
                  fontWeight={500}
                  px="10px"
                  py="12px"
                  borderRadius="10px"
                  color="lightStatic.main"
                  icon2={<ArrowLeftSVG size={32} />}
                  mt="16px"
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
